import http from '@/api/http';
import { serialize } from '@/utils/format';

export async function getAll(token) {
    try {
        const response = await http.get('api/v3/user/message',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function readAll(token) {
    try {
        const response = await http.get('api/v3/user/message/read-all',
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}

export async function readOne(token, id) {
    try {
        const response = await http.get('api/v3/user/message/read?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            })
        return response.data
    } catch (error) {
        console.log(error.response)
        return null
    }
}